"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@rjsf/utils");
const react_json_schema_utils_1 = require("@squiz/react-json-schema-utils");
const ArrayOfPrimitives_1 = __importDefault(require("./ArrayOfPrimitives"));
const ArrayOfGroups_1 = __importDefault(require("./ArrayOfGroups"));
const ArrayFieldTemplate = (props) => {
    const { schema } = props;
    const fixedItemCount = schema.items instanceof Array ? schema.items.length : 0;
    const itemTypes = [];
    // "getSchemaType" automatically infers the schema type from other parts of the schema.
    // https://rjsf-team.github.io/react-jsonschema-form/docs/api-reference/utility-functions#getschematype
    if (typeof schema.items === 'object' && !(schema.items instanceof Array)) {
        itemTypes.push(schema.items.customType?.customType || (0, utils_1.getSchemaType)(schema.items));
    }
    if (typeof schema.additionalItems === 'object') {
        itemTypes.push((0, utils_1.getSchemaType)(schema.additionalItems));
    }
    if (itemTypes.includes('object') ||
        itemTypes.includes('array') ||
        itemTypes.includes(react_json_schema_utils_1.CustomJsonSchemaType.SquizLink) ||
        itemTypes.length === 0) {
        return react_1.default.createElement(ArrayOfGroups_1.default, { ...props, fixedItemCount: fixedItemCount });
    }
    return react_1.default.createElement(ArrayOfPrimitives_1.default, { ...props, fixedItemCount: fixedItemCount });
};
exports.default = ArrayFieldTemplate;
